jQuery(document).ready(function($) {
    if (!window.Shopify.designMode) {
        $('a[href^="#"]').not('[href="#"]').not('[href="#0"]').on('click', function(e) {
            var anchor = this.hash;
            var target = $(anchor);
            if (target.length) {
            e.preventDefault();

            $('html, body').stop().animate({
                scrollTop: target.offset().top - 30 
            }, 800, function() {
                window.location.hash = anchor;
            });
            }
        });
    }
});